import React from 'react';
import ReactDOM from 'react-dom';

interface AdjustDecisionModalProps {
    isOpen: boolean;
    type: 'approve' | 'reject';
    onClose: () => void;
    onConfirm: () => void;
    adjustDirection: string;   // 'add' | 'deduct'
    adjustAmount: number;
    currentTotalPay: number;
    paymentFeeRate: number;    // 결제 수수료율 (%)
}

export const AdjustDecisionModal: React.FC<AdjustDecisionModalProps> = ({
    isOpen, type, onClose, onConfirm,
    adjustDirection, adjustAmount, currentTotalPay, paymentFeeRate,
}) => {
    const modalRoot = document.getElementById('modal-root');

    React.useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
        }
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    if (!isOpen || !modalRoot) return null;

    const isApprove = type === 'approve';
    const title = isApprove ? '조정 승인' : '조정 거절';
    const isAdd = adjustDirection === 'add';
    const sign = isAdd ? '+' : '-';
    const finalPay = isAdd
        ? currentTotalPay + adjustAmount
        : currentTotalPay - adjustAmount;
    // 수수료는 조정 금액(순서비스) 기준으로 절사 — 백엔드와 동일
    const paymentFee = Math.floor((adjustAmount * (paymentFeeRate || 0)) / 100);
    // 회원 실제 지갑 변동액 = 조정 금액 + 수수료 (add: 추가결제 / deduct: 환불)
    const grossAmount = adjustAmount + paymentFee;
    const actualLabel = isAdd ? '추가 결제 금액' : '환불 금액';

    return ReactDOM.createPortal(
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ backgroundColor: 'white' }}>
                    <div className="modal-header line-header">
                        <h3>{title}</h3>
                    </div>

                    <div className="modal-body">
                        <div className="round-box mt10">
                            <div className="round-body">
                                <div className="info-row">
                                    <span className="label">급여 조정 금액</span>
                                    <span className="cont">
                                        <strong className="text-red">
                                            {sign}{adjustAmount.toLocaleString()} 원
                                        </strong>
                                    </span>
                                </div>
                                <div className="info-row">
                                    <span className="label">최종 급여 금액</span>
                                    <span className="cont">
                                        <strong>{finalPay.toLocaleString()} 원</strong>
                                    </span>
                                </div>
                                {isApprove && (
                                    <>
                                        <div className="info-row top-line">
                                            <span className="label">수수료</span>
                                            <span className="cont">{sign}{paymentFee.toLocaleString()} 원</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">{actualLabel}</span>
                                            <span className="cont">
                                                <strong>{grossAmount.toLocaleString()} 원</strong>
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="modal-info-p mt20">
                            {isApprove ? (
                                <>
                                    {isAdd ? (
                                        <span className="block">승인 시 조정 금액과 수수료 합계 {grossAmount.toLocaleString()}원이 추가 결제됩니다.</span>
                                    ) : (
                                        <span className="block">승인 시 조정 금액과 해당 수수료 합계 {grossAmount.toLocaleString()}원이 환불됩니다.</span>
                                    )}
                                    <strong className="block mt10">코디의 돌봄 급여 금액 조정 신청을</strong>
                                    <strong className="block">승인하시겠습니까?</strong>
                                </>
                            ) : (
                                <>
                                    <strong className="block">코디의 돌봄 급여 금액 조정 신청을</strong>
                                    <strong className="block">거절하시겠습니까?</strong>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button type="button" className="btn cancel" onClick={onClose}>취소</button>
                            <button type="button" className="btn confirm" onClick={onConfirm}>
                                {isApprove ? '승인' : '거절'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        modalRoot
    );
};
